import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  textWhite: {
    color: 'white',
    textTransform: 'uppercase',
  },
}));

const CoreValues = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title={<span className={classes.textWhite}></span>}
        titleVariant="h1"
        subtitle={<span className={classes.textWhite}></span>}
        disableGutter
        data-aos="fade-up"
      />
    </div>
  );
};

CoreValues.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default CoreValues;
